import * as React from 'react';
import { SVGProps } from 'react';

const IconCommentDeleteFilledSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 2h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H6l-4 4V4c0-1.1.9-2 2-2Zm13.207 4.207L13.414 10l3.793 3.793-1.414 1.414L12 11.414l-3.793 3.793-1.414-1.414L10.586 10 6.793 6.207l1.414-1.414L12 8.586l3.793-3.793 1.414 1.414Z"
    />
  </svg>
);
export default IconCommentDeleteFilledSizeM;
